import React from 'react';
import * as S from './styled';

export default function TitleTab({ title = 'Não definido' }) {
	return <S.containerTitleTab>{title}</S.containerTitleTab>;
}
